var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSlidingDoorIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#BDDCD7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.81381 5.5C6.39963 5.5 6.00035 6.08545 6.00035 6.5V8.5L6 25.75C6 26.1646 6.08582 26.5 6.5 26.5C6.91418 26.5 7.00035 26.1646 7.00035 25.75L7 9H12.2503V25.75C12.2503 26.1646 12.5862 26.5 13.0003 26.5H23.5003C23.9149 26.5 24.2503 26.1646 24.2503 25.75H25.7503C26.1649 25.75 26.5003 25.4146 26.5003 25V8.5V6.25C26.5003 5.83545 26.1649 5.5 25.7503 5.5H6.81381ZM7.00035 6.5H25.5V8H7L7.00035 6.5ZM13.5 9H23.5003V25.5H13.5V9ZM24.2503 9H25.5V25H24.2503V9ZM8.50035 15.25C8.30845 15.25 8.11656 15.3232 7.97007 15.4697C7.67711 15.7627 7.70703 16.207 8 16.5L9 17.5L8 18.5C7.70703 18.793 7.70703 19.0612 8 19.3542C8.14648 19.5006 8.5 19.5 8.5 19.5C8.5 19.5 8.79332 19.5006 8.9398 19.3542L10 18C10.293 17.707 10.293 17.293 10 17L8.9398 15.5646C8.79332 15.4182 8.69224 15.25 8.50035 15.25ZM15.5 16C15.0858 16 15 16.3354 15 16.75V18.25C15 18.6646 15.0858 19 15.5 19C15.9142 19 16.0003 18.6646 16.0003 18.25V16.75C16.0003 16.3354 15.9142 16 15.5 16Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSlidingDoorIcon);
export default __webpack_public_path__ + "static/media/slidingDoorIcon.1b30f2e496e345e472ec8147c7ed0ecc.svg";
export { ForwardRef as ReactComponent };